import { render, staticRenderFns } from "./ComplianceStatus.vue?vue&type=template&id=f59ae1e8&"
import script from "./ComplianceStatus.vue?vue&type=script&lang=js&"
export * from "./ComplianceStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports